import * as localforage from "localforage";
import axios from "axios";
import { successHandling } from "../helpers/successHandling";

export const createAppApi = async (
  os_type,
  name,
  version,
  s3_path,
  md5,
  description,
  install_script,
  uninstall_script,
  t,
  successText,
  setLoading
) => {
  const company_id = await localforage.getItem("companyId");
  try {
    let res = await axios({
      url: `/api/v2/application/create`,
      method: "POST",
      data: {
        company_id,
        os_type,
        name,
        version,
        s3_path,
        md5,
        description,
        install_script,
        uninstall_script
      }
    });
    successHandling(t, successText);
    return res.data;
  } catch (error) {
    setLoading(false);
  }
};

export const deleteAppApi = async (application_ids, t, successfulText) => {
  let res = await axios({
    url: `/api/v2/application/delete`,
    method: "DELETE",
    data: {
      application_ids
    }
  });
  successHandling(t, successfulText);
  return res.data;
};

export const deleteVersionApi = async (
  application_id,
  application_version_ids,
  t,
  successfulText
) => {
  let res = await axios({
    url: `/api/v2/application/delete-version`,
    method: "DELETE",
    data: {
      application_id,
      application_version_ids
    }
  });
  successHandling(t, successfulText);
  return res.data;
};

export const appVersionDetailApi = async application_id => {
  let res = await axios({
    url: `/api/v2/application/versions`,
    method: "GET",
    params: {
      application_id
    }
  });
  return res.data;
};

export const createAppVersionApi = async (
  application_id,
  version,
  s3_path,
  md5,
  description,
  install_script,
  uninstall_script,
  t,
  successText,
  setLoading
) => {
  try {
    let res = await axios({
      url: `/api/v2/application/version/create`,
      method: "POST",
      data: {
        application_id,
        version,
        s3_path,
        md5,
        description,
        install_script,
        uninstall_script
      }
    });
    successHandling(t, successText);
    return res.data;
  } catch (error) {
    setLoading(false);
  }
};

export const setVersionApi = async (
  application_version_id,
  is_publish,
  group_ids,
  t,
  successText
) => {
  let res = await axios({
    url: `/api/v2/application/set-version-publish`,
    method: "POST",
    data: {
      execute_type: "install_application",
      application_version_id,
      is_publish,
      group_ids
    }
  });
  if (t && successText) {
    successHandling(t, successText);
  }
  return res.data;
};

export const getGroupListApi = async () => {
  const company_id = await localforage.getItem("companyId");

  let res = await axios({
    url: `/api/v2/groups`,
    method: "GET",
    params: {
      company_id,
      group_category_name: "app_update_service"
    }
  });
  return res.data.groups;
};
